import { Button } from "@/components/ui/button";
import { type ReactNode } from "react";

interface NavigationItemProps {
  icon: ReactNode;
  label: string;
  isActive?: boolean;
  onClick?: () => void;
  isCollapsed?: boolean;
}

export function NavigationItem({
  icon,
  label,
  isActive,
  onClick,
  isCollapsed,
}: NavigationItemProps) {
  return (
    <Button
      variant="ghost"
      onClick={onClick}
      className={`w-full ${isCollapsed ? "justify-center" : "justify-start"} gap-[8px] h-[43px] px-3 py-2 ${
        isActive ? "nav-item-active" : "nav-item-inactive"
      } hover:bg-sidebar-active-bg/10`}
      title={isCollapsed ? label : undefined}
    >
      {icon}
      {!isCollapsed && (
        <span
          className={`text-[15px] font-lexend font-normal tracking-[-0.22px] capitalize ${
            isActive ? "text-sidebar-active-text" : "text-sidebar-text"
          }`}
        >
          {label}
        </span>
      )}
    </Button>
  );
}
